import script from "./WorkdaySelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./WorkdaySelector.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__